<div *im2mLet="stateData$ | async as data" [ngClass]="data?.styleClass" class="router-state">
    {{ data?.state ? ('DEVICES.STATES.' + data?.state | transloco) : '-' }}
    <mat-spinner [diameter]="16" *ngIf="data?.state === STATE.CertDownload || data?.state === STATE.FwDownloading"></mat-spinner>
</div>
